<div class="tenant-and-region-container" [class.flexRowParentEqualChildren]="horizontalView">
    <ac-input-container [formFieldName]="tenantFormFieldName || 'tenantId'" [label]="tenantLabel || 'Tenant'" [class.flexItemRowEquals]="horizontalView">
        <ac-single-select [sortItems]="sortTenants"
                   [acModel]="model.tenantId || additionalSettings.tenantId"
                   [items]="tenants"
                   bindLabel="name"
                   bindValue="id"
                   [ngDisabled]="ngDisabledTenant"
                   [overrideSystemViewMode]="overrideSystemViewMode"
                   (acModelChange)="onTenantChange($event);">
        </ac-single-select>
    </ac-input-container>

    <ac-input-container [formFieldName]="regionFormFieldName" label="Region" *ngIf="showRegion" [class.flexItemRowEquals]="horizontalView">
        <ac-single-select [sortItems]="true"
                   [acModel]="model.regionId || additionalSettings.regionId"
                   [items]="regionsByTenant"
                   (acModelChange)="model.regionId = $event; acRegionChanged.emit($event)"
                   bindLabel="name"
                   bindValue="id"
                   [ngDisabled]="ngDisabledRegion">
        </ac-single-select>
    </ac-input-container>
</div>

